
<div class="chapt">
    <ul>
        <li class="z-depth-4 center" *ngFor="let chapter of chapters" (click)="getSlokas(chapter.route)"> 
           <a class="pink-text"> {{ chapter.chapt}}</a>
    
        </li>
    </ul>

    <!-- <ul class="tabs z-depth-1">
        <li class="tab hoverable" *ngFor="let chapter of chapters" (click)="getSlokas(chapter.route)">
          <a href="#!">  {{ chapter.chapt}} </a>
        </li>
      </ul> -->

</div> 



<div id="showCompGraph" class="modal modal-fixed-footer" style="width: 35% !important;">
    <div class="modal-content">
        <div class="container text-center">
            <h6> {{ compInput }}</h6>
            <hr>
            <div [innerHTML]="svgTemplate" class="text-center"> </div>
        </div>
      
    </div>
    <div class="modal-footer">
      <a href="#!" class="modal-close waves-effect waves-green btn-flat">Close</a>
    </div>
  </div>


<div class="sloka">
    
    <ul class="grey lighten-4">
        <li class=" pink-text white"  *ngFor="let item of texts" (click)="getAnalysis(item.chaptno, item.slokano)">
            <span style="font-size: xx-small;" class="center"> श्लोकसंख्या : {{item.slokano}} </span><hr>
            
            <a class="collection-item black-text"> 
                {{item.spart1}}<br>
                {{item.spart2}}
    
            </a>
        </li>
    </ul> 
</div>

<!-- <router-outlet name='sloka'></router-outlet> -->
<div class="analysis2222" *ngIf="shwAna">

        <h6 class="purple-text" style="margin-left: 30px;"> <b>You selected Chapter {{chapterNo}} and Sloka {{slokaNo}}</b> &nbsp;&nbsp;&nbsp;&nbsp; <span class="red-text">[Click on graph for zoom view]</span></h6>
  
        
    <ul>
        
       
        <li class="analysis">
           <!-- <div > -->
            <div class="row">
                <div class="col s12 l8">
                    <ul *ngIf="sentOne.checked == true">
                        <li style='float:left;position: relative;'>
                            <table> 
                                <tr *ngIf="wordNo.checked == true">
                                    <td> Word No. </td>
                                </tr>
                                <tr (click)="showGraf('1')" *ngIf="sanskrit.checked == true">
                                    <td class="pink-text">  1.1.A. </td>
                                </tr>
                                <tr *ngIf="sktwithoutsandhi.checked == true">
                                    <td>  1.1.B. </td>
                                </tr>
     
                                <tr *ngIf="multimorf.checked == true">
                                    <td>  1.1.C. </td>
                                </tr>
    
                                <tr *ngIf="mrfInContext.checked == true">
                                    <td>  1.1.D. </td>
                                </tr>
    
                                <tr *ngIf="samaasa.checked == true">
                                    <td>  1.1.E. </td>
                                </tr>
    
                                <tr *ngIf="samaasavigraha.checked == true">
                                    <td>  1.1.F. </td>
                                </tr>
                
                                <tr *ngIf="kaarakarel.checked == true">
                                    <td>  1.1.G. </td>
                                </tr>
                
                                <tr *ngIf="cate.checked == true">
                                    <td>  --- </td>
                                </tr>
                                <tr *ngIf="hindimean.checked == true">
                                    <td>  1.1.I.</td>
                                </tr>
                
                                <tr *ngIf="engmean.checked == true">
                                    <td>  1.1.J.</td>
                                </tr>
                                <tr *ngIf="derimean.checked == true">
                                    <td>  1.1.K.</td>
                                </tr>
                                <tr *ngIf="sandhirule.checked == true">
                                    <td>  1.1.L.</td>
                                </tr>
                                <tr *ngIf="meter.checked == true">
                                    <td>  1.1.M.</td>
                                </tr>
                                
                
                                
                                
                            </table>
                        </li>
                        <li *ngFor="let item of sentOneAna; let i=index" [style.background-color]="item.bgcolor">
                            <table> 
                                <tr *ngIf="wordNo.checked == true">
                                    <td> {{i+1}}</td>
                                </tr> 
                                 <tr *ngIf="sanskrit.checked == true">
                                     <td>  {{item.word}} </td>
                                 </tr>
                 
                                  <tr *ngIf="sktwithoutsandhi.checked == true">
                                    <td>  {{item.sandhied_word}} </td>
                                </tr>
    
                                <tr *ngIf="multimorf.checked == true">
                                    <td>  {{item.morph_analysis}} 
                                    </td>
                                </tr>
    
                                <tr *ngIf="mrfInContext.checked == true">
                                    <td> 
                                        <!-- <a href="https://sanskrit.uohyd.ac.in/cgi-bin/scl/e-readers/sbg/options1.cgi?word={{getStem(item.morph_in_context)}}&outencoding=DEV" target="popup" onclick="window.open('','popup','width=600,height=600')" style="color:black;text-decoration:underline;"> {{getStem(item.morph_in_context)}}</a>  -->
                                        <!-- <div [innerHTML]="ttest"></div> -->
                                        
                                       
                                        {{getStem2(item.morph_in_context)}}
                                         <a href="https://sanskrit.uohyd.ac.in/cgi-bin/scl/e-readers/sbg/options1.cgi?word={{item.stem}}&outencoding=DEV"  target="popup" onclick="window.open('','popup','width=600,height=600')" style="color:black;text-decoration:underline;" *ngFor="let item of stems; let i=index"><span *ngIf="i>0">-</span>{{item.stem}}  </a> 
                                       
                                        {{"{"+getFeat(item.morph_in_context)}}</td> 
                                   
                                </tr>
    
                                <tr *ngIf="samaasa.checked == true">
                                    <td> 
                                        <a *ngIf="item.samAsa !='-'" style="color:black;text-decoration: underline;" (click)="createGraph(item.samAsa)" class="modal-trigger" href="#showCompGraph"> {{item.samAsa}} </a> 
                                        <a *ngIf="item.samAsa =='-'"> {{item.samAsa}} </a> 
                                         
                                    </td>
                                    
                                </tr>
    
                                <tr *ngIf="samaasavigraha.checked == true">
                                    <td>  {{item.samAsa}}. </td>
                                </tr>
                
                                <tr *ngIf="kaarakarel.checked == true">
                                    <td>  {{item.kaaraka_sambandha}} </td>
                                </tr>
                
                                <tr *ngIf="cate.checked == true">
                                    <td>  --- </td>
                                </tr>
                                <tr *ngIf="hindimean.checked == true">
                                    <td>  {{item.hindi_meaning}}</td>
                                </tr>
                
                                <tr *ngIf="engmean.checked == true">
                                    <td>  {{item.english_meaning}}</td>
                                </tr>
                                <tr *ngIf="derimean.checked == true">
                                    <td>  --- </td>
                                </tr>
                                <tr *ngIf="sandhirule.checked == true">
                                    <td>  --- </td>
                                </tr> 
                                 <tr *ngIf="meter.checked == true">
                                    <td>  --- </td>
                                </tr>
                                
                             </table>
                        
                        </li>
                    </ul>
                </div>
                <div class="col s12 l4">
                    <div  class="center sticky" *ngIf="sentOneStat == 'yes'">
                        
                        <a class="modal-trigger" href="#modal2" (click)="showGraf(sentOneGraf)"> <img src="{{sentOneGraf}}" width="100%" height="250"> </a>
            
                    </div>
                </div>
            </div>
            
               
            <div class="row">
                <div class="col s12 l8">

                <ul *ngIf="(sentTwoStat == 'yes' && sentTwo.checked == true)">
                    <li style='float:left;position: relative;'>
                        <table> 
                            <tr *ngIf="wordNo.checked == true">
                                <td> Word No. </td>
                            </tr>
                            <tr (click)="showGraf('2')" *ngIf="sanskrit.checked == true">
                                <td class="pink-text">  1.2.A. </td>
                            </tr>
                            <tr *ngIf="sktwithoutsandhi.checked == true">
                                <td>  1.2.B. </td>
                            </tr>
 
                            <tr *ngIf="multimorf.checked == true">
                                <td>  1.2.C. </td>
                            </tr>

                            <tr *ngIf="mrfInContext.checked == true">
                                <td>  1.2.D. </td>
                            </tr>

                            <tr *ngIf="samaasa.checked == true">
                                <td>  1.2.E. </td>
                            </tr>

                            <tr *ngIf="samaasavigraha.checked == true">
                                <td>  1.2.F. </td>
                            </tr>
            
                            <tr *ngIf="kaarakarel.checked == true">
                                <td>  1.2.G. </td>
                            </tr>
            
                            <tr *ngIf="cate.checked == true">
                                <td>  1.2.H.</td>
                            </tr>
                            <tr *ngIf="hindimean.checked == true">
                                <td>  1.2.I.</td>
                            </tr>
            
                            <tr *ngIf="engmean.checked == true">
                                <td>  1.2.J.</td>
                            </tr>
                            <tr *ngIf="derimean.checked == true">
                                <td>  1.2.K.</td>
                            </tr>
                            <tr *ngIf="sandhirule.checked == true">
                                <td>  1.2.L.</td>
                            </tr>
                            <tr *ngIf="meter.checked == true">
                                <td>  1.2.M.</td>
                            </tr>
                            
            
                            
                            
                        </table>
                    </li>
                    <li *ngFor="let item of sentTwoAna; let i=index" [style.background-color]="item.bgcolor" (click)="showGraf(item.graph)">
                        <table> 
                            <tr *ngIf="wordNo.checked == true">
                                <td> {{i+1}}</td>
                            </tr> 
                             <tr *ngIf="sanskrit.checked == true">
                                 <td>  {{item.word}} </td>
                             </tr>
             
                              <tr *ngIf="sktwithoutsandhi.checked == true">
                                <td>  {{item.sandhied_word}} </td>
                            </tr>

                            <tr *ngIf="multimorf.checked == true">
                                <td>  {{item.morph_analysis}} </td>
                            </tr>

                            <tr *ngIf="mrfInContext.checked == true">
                                <td> 
                                    <!-- <a href="https://sanskrit.uohyd.ac.in/cgi-bin/scl/e-readers/sbg/options1.cgi?word={{getStem(item.morph_in_context)}}&outencoding=DEV" target="popup" onclick="window.open('','popup','width=600,height=600')" style="color:black;text-decoration:underline;"> {{getStem(item.morph_in_context)}}</a>  -->
                                    {{getStem2(item.morph_in_context)}}
                                         <a href="https://sanskrit.uohyd.ac.in/cgi-bin/scl/e-readers/sbg/options1.cgi?word={{item.stem}}&outencoding=DEV"  target="popup" onclick="window.open('','popup','width=600,height=600')" style="color:black;text-decoration:underline;" *ngFor="let item of stems; let i=index"> <span *ngIf="i>0">-</span>{{item.stem}} </a> 
                                       
                                    {{"{"+getFeat(item.morph_in_context)}}</td>
                                   
                            </tr>

                            <tr *ngIf="samaasa.checked == true">
                                <td> 
                                    <a *ngIf="item.samAsa !='-'" style="color:black;text-decoration: underline;" (click)="createGraph(item.samAsa)" class="modal-trigger" href="#showCompGraph"> {{item.samAsa}} </a> 
                                    <a *ngIf="item.samAsa =='-'"> {{item.samAsa}} </a> 
                                </td>
                               
                            </tr>

                            <tr *ngIf="samaasavigraha.checked == true">
                                <td>  {{item.samAsa}}. </td>
                            </tr>
            
                            <tr *ngIf="kaarakarel.checked == true">
                                <td>  {{item.kaaraka_sambandha}} </td>
                            </tr>
            
                            <tr *ngIf="cate.checked == true">
                                <td>  --- </td>
                            </tr>
                            <tr *ngIf="hindimean.checked == true">
                                <td>  {{item.hindi_meaning}}</td>
                            </tr>
            
                            <tr *ngIf="engmean.checked == true">
                                <td>  {{item.english_meaning}}</td>
                            </tr>
                            <tr *ngIf="derimean.checked == true">
                                <td>  --- </td>
                            </tr>
                            <tr *ngIf="sandhirule.checked == true">
                                <td>  --- </td>
                            </tr> 
                             <tr *ngIf="meter.checked == true">
                                <td>  --- </td>
                            </tr>
                            
                         </table>
                    
                    </li>
                </ul>
            </div>
            <div class="col s12 l4">
                <div  class="center sticky" *ngIf="(sentTwoStat == 'yes' && sentTwo.checked == true)">
                    <a class="modal-trigger" href="#modal2" (click)="showGraf(sentTwoGraf)"> <img src="{{sentTwoGraf}}" width="100%" height="200px"> </a>
        
                </div>
            </div>
        </div>


        <div class="row">
            <div class="col s12 l8">
                <ul *ngIf="(sentThreeStat == 'yes' && sentThree.checked == true)">
                    <li style='float:left;position: relative;'>
                        <table> 
                            <tr *ngIf="wordNo.checked == true">
                                <td> Word No. </td>
                            </tr>
                            <tr (click)="showGraf('3')" *ngIf="sanskrit.checked == true">
                                <td class="pink-text">  1.3.A. </td>
                            </tr>
                            <tr *ngIf="sktwithoutsandhi.checked == true">
                                <td>  1.3.B. </td>
                            </tr>
 
                            <tr *ngIf="multimorf.checked == true">
                                <td>  1.3.C. </td>
                            </tr>

                            <tr *ngIf="mrfInContext.checked == true">
                                <td>  1.3.D. </td>
                            </tr>

                            <tr *ngIf="samaasa.checked == true">
                                <td>  1.3.E. </td>
                            </tr>

                            <tr *ngIf="samaasavigraha.checked == true">
                                <td>  1.3.F. </td>
                            </tr>
            
                            <tr *ngIf="kaarakarel.checked == true">
                                <td>  1.3.G. </td>
                            </tr>
            
                            <tr *ngIf="cate.checked == true">
                                <td>  1.3.H.</td>
                            </tr>
                            <tr *ngIf="hindimean.checked == true">
                                <td>  1.3.I.</td>
                            </tr>
            
                            <tr *ngIf="engmean.checked == true">
                                <td>  1.3.J.</td>
                            </tr>
                            <tr *ngIf="derimean.checked == true">
                                <td>  1.3.K.</td>
                            </tr>
                            <tr *ngIf="sandhirule.checked == true">
                                <td>  1.3.L.</td>
                            </tr>
                            <tr *ngIf="meter.checked == true">
                                <td>  1.3.M.</td>
                            </tr>
                            
            
                            
                            
                        </table>
                    </li>
                    <li *ngFor="let item of sentThreeAna;let i=index" [style.background-color]="item.bgcolor" (click)="showGraf(item.graph)">
                        <table> 
                            <tr *ngIf="wordNo.checked == true">
                                <td> {{i+1}}</td>
                            </tr> 
                             <tr *ngIf="sanskrit.checked == true">
                                 <td>  {{item.word}} </td>
                             </tr>
             
                              <tr *ngIf="sktwithoutsandhi.checked == true">
                                <td>  {{item.sandhied_word}} </td>
                            </tr>

                            <tr *ngIf="multimorf.checked == true">
                                <td>  {{item.morph_analysis}} </td>
                            </tr>

                            <tr *ngIf="mrfInContext.checked == true">
                                <td> 
                                    <!-- <a href="https://sanskrit.uohyd.ac.in/cgi-bin/scl/e-readers/sbg/options1.cgi?word={{getStem(item.morph_in_context)}}&outencoding=DEV" target="popup" onclick="window.open('','popup','width=600,height=600')" style="color:black;text-decoration:underline;"> {{getStem(item.morph_in_context)}}</a>  -->
                                    {{getStem2(item.morph_in_context)}}
                                         <a href="https://sanskrit.uohyd.ac.in/cgi-bin/scl/e-readers/sbg/options1.cgi?word={{item.stem}}&outencoding=DEV"  target="popup" onclick="window.open('','popup','width=600,height=600')" style="color:black;text-decoration:underline;" *ngFor="let item of stems; let i=index"> <span *ngIf="i>0">-</span>{{item.stem}} </a> 
                                       
                                    {{"{"+getFeat(item.morph_in_context)}}</td>
                                   
                            </tr>

                            <tr *ngIf="samaasa.checked == true">
                                <td> 
                                    <a *ngIf="item.samAsa !='-'" style="color:black;text-decoration: underline;" (click)="createGraph(item.samAsa)" class="modal-trigger" href="#showCompGraph"> {{item.samAsa}} </a> 
                                    <a *ngIf="item.samAsa =='-'"> {{item.samAsa}} </a> 
                                </td>
                             
                            </tr>

                            <tr *ngIf="samaasavigraha.checked == true">
                                <td>  {{item.samAsa}}. </td>
                            </tr>
            
                            <tr *ngIf="kaarakarel.checked == true">
                                <td>  {{item.kaaraka_sambandha}} </td>
                            </tr>
            
                            <tr *ngIf="cate.checked == true">
                                <td>  --- </td>
                            </tr>
                            <tr *ngIf="hindimean.checked == true">
                                <td>  {{item.hindi_meaning}}</td>
                            </tr>
            
                            <tr *ngIf="engmean.checked == true">
                                <td>  {{item.english_meaning}}</td>
                            </tr>
                            <tr *ngIf="derimean.checked == true">
                                <td>  --- </td>
                            </tr>
                            <tr *ngIf="sandhirule.checked == true">
                                <td>  --- </td>
                            </tr> 
                             <tr *ngIf="meter.checked == true">
                                <td>  --- </td>
                            </tr>
                            
                         </table>
                    
                    </li>
                </ul>
            </div>
            <div class="col s12 l4">
                <div  class="center sticky" *ngIf="(sentThreeStat == 'yes' && sentThree.checked == true)">
                    <a class="modal-trigger" href="#modal2" (click)="showGraf(sentThreeGraf)"> <img src="{{sentThreeGraf}}" width="100%" height="200px"> </a>
        
                </div>
            </div>
        </div>
           <!-- Fourth Analysis -->
        <div class="row">
            <div class="col s12 l8">
                <ul *ngIf="(sentFourStat == 'yes' && sentFour.checked == true)">
                    <li style='float:left;position: relative;'>
                        <table> 
                            <tr *ngIf="wordNo.checked == true">
                                <td> Word No. </td>
                            </tr>
                            <tr (click)="showGraf('4')" *ngIf="sanskrit.checked == true">
                                <td class="pink-text">  1.4.A. </td>
                            </tr>
                            <tr *ngIf="sktwithoutsandhi.checked == true">
                                <td>  1.4.B. </td>
                            </tr>
 
                            <tr *ngIf="multimorf.checked == true">
                                <td>  1.4.C. </td>
                            </tr>

                            <tr *ngIf="mrfInContext.checked == true">
                                <td>  1.4.D. </td>
                            </tr>

                            <tr *ngIf="samaasa.checked == true">
                                <td>  1.4.E. </td>
                            </tr>

                            <tr *ngIf="samaasavigraha.checked == true">
                                <td>  1.4.F. </td>
                            </tr>
            
                            <tr *ngIf="kaarakarel.checked == true">
                                <td>  1.4.G. </td>
                            </tr>
            
                            <tr *ngIf="cate.checked == true">
                                <td>  1.4.H.</td>
                            </tr>
                            <tr *ngIf="hindimean.checked == true">
                                <td>  1.4.I.</td>
                            </tr>
            
                            <tr *ngIf="engmean.checked == true">
                                <td>  1.4.J.</td>
                            </tr>
                            <tr *ngIf="derimean.checked == true">
                                <td>  1.4.K.</td>
                            </tr>
                            <tr *ngIf="sandhirule.checked == true">
                                <td>  1.4.L.</td>
                            </tr>
                            <tr *ngIf="meter.checked == true">
                                <td>  1.4.M.</td>
                            </tr>
                            
            
                            
                            
                        </table>
                    </li>
                    <li *ngFor="let item of sentFourAna;let i=index" [style.background-color]="item.bgcolor" (click)="showGraf(item.graph)">
                        <table> 
                            <tr *ngIf="wordNo.checked == true">
                                <td> {{i+1}}</td>
                            </tr> 
                             <tr *ngIf="sanskrit.checked == true">
                                 <td>  {{item.word}} </td>
                             </tr>
             
                              <tr *ngIf="sktwithoutsandhi.checked == true">
                                <td>  {{item.sandhied_word}} </td>
                            </tr>

                            <tr *ngIf="multimorf.checked == true">
                                <td>  {{item.morph_analysis}} </td>
                            </tr>

                            <tr *ngIf="mrfInContext.checked == true">
                                <td> 
                                    <!-- <a href="https://sanskrit.uohyd.ac.in/cgi-bin/scl/e-readers/sbg/options1.cgi?word={{getStem(item.morph_in_context)}}&outencoding=DEV" target="popup" onclick="window.open('','popup','width=600,height=600')" style="color:black;text-decoration:underline;"> {{getStem(item.morph_in_context)}}</a>  -->
                                    {{getStem2(item.morph_in_context)}}
                                         <a href="https://sanskrit.uohyd.ac.in/cgi-bin/scl/e-readers/sbg/options1.cgi?word={{item.stem}}&outencoding=DEV"  target="popup" onclick="window.open('','popup','width=600,height=600')" style="color:black;text-decoration:underline;" *ngFor="let item of stems; let i=index"> <span *ngIf="i>0">-</span>{{item.stem}} </a> 
                                       
                                    {{"{"+getFeat(item.morph_in_context)}}</td>
                                   
                            </tr>

                            <tr *ngIf="samaasa.checked == true">
                                <td> 
                                    <a *ngIf="item.samAsa !='-'" style="color:black;text-decoration: underline;" (click)="createGraph(item.samAsa)" class="modal-trigger" href="#showCompGraph"> {{item.samAsa}} </a>  
                                    <a *ngIf="item.samAsa =='-'"> {{item.samAsa}} </a> 
                                </td>
                              
                            </tr>

                            <tr *ngIf="samaasavigraha.checked == true">
                                <td>  {{item.samAsa}}. </td>
                            </tr>
            
                            <tr *ngIf="kaarakarel.checked == true">
                                <td>  {{item.kaaraka_sambandha}} </td>
                            </tr>
            
                            <tr *ngIf="cate.checked == true">
                                <td>  --- </td>
                            </tr>
                            <tr *ngIf="hindimean.checked == true">
                                <td>  {{item.hindi_meaning}}</td>
                            </tr>
            
                            <tr *ngIf="engmean.checked == true">
                                <td>  {{item.english_meaning}}</td>
                            </tr>
                            <tr *ngIf="derimean.checked == true">
                                <td>  --- </td>
                            </tr>
                            <tr *ngIf="sandhirule.checked == true">
                                <td>  --- </td>
                            </tr> 
                             <tr *ngIf="meter.checked == true">
                                <td>  --- </td>
                            </tr>
                            
                         </table>
                    
                    </li>
                </ul>
            </div>
            <div class="col s12 l4">
                <div  class="center sticky" *ngIf="(sentFourStat == 'yes'  && sentFour.checked == true)">
                    <a class="modal-trigger" href="#modal2" (click)="showGraf(sentFourGraf)"> <img src="{{sentFourGraf}}" width="100%" height="200px"> </a>
        
                </div>
            </div>
        </div>
            
        <!-- Fifth Analysis  -->
                        
        <div class="row">
            <div class="col s12 l8">
                <ul *ngIf="(sentFiveStat == 'yes' && sentFive.checked == true)">
                    <li style='float:left;position: relative;'>
                        <table> 
                            <tr *ngIf="wordNo.checked == true">
                                <td> Word No. </td>
                            </tr>
                            <tr (click)="showGraf('5')" *ngIf="sanskrit.checked == true">
                                <td class="pink-text">  1.5.A. </td>
                            </tr>
                            <tr *ngIf="sktwithoutsandhi.checked == true">
                                <td>  1.5.B. </td>
                            </tr>
 
                            <tr *ngIf="multimorf.checked == true">
                                <td>  1.5.C. </td>
                            </tr>

                            <tr *ngIf="mrfInContext.checked == true">
                                <td>  1.5.D. </td>
                            </tr>

                            <tr *ngIf="samaasa.checked == true">
                                <td>  1.5.E. </td>
                            </tr>

                            <tr *ngIf="samaasavigraha.checked == true">
                                <td>  1.5.F. </td>
                            </tr>
            
                            <tr *ngIf="kaarakarel.checked == true">
                                <td>  1.5.G. </td>
                            </tr>
            
                            <tr *ngIf="cate.checked == true">
                                <td>  1.5.H.</td>
                            </tr>
                            <tr *ngIf="hindimean.checked == true">
                                <td>  1.5.I.</td>
                            </tr>
            
                            <tr *ngIf="engmean.checked == true">
                                <td>  1.5.J.</td>
                            </tr>
                            <tr *ngIf="derimean.checked == true">
                                <td>  1.5.K.</td>
                            </tr>
                            <tr *ngIf="sandhirule.checked == true">
                                <td>  1.5.L.</td>
                            </tr>
                            <tr *ngIf="meter.checked == true">
                                <td>  1.5.M.</td>
                            </tr>
                            
            
                            
                            
                        </table>
                    </li>
                    <li *ngFor="let item of sentFiveAna;let i=index" [style.background-color]="item.bgcolor" (click)="showGraf(item.graph)">
                        <table> 
                            <tr *ngIf="wordNo.checked == true">
                                <td> {{i+1}}</td>
                            </tr> 
                             <tr *ngIf="sanskrit.checked == true">
                                 <td>  {{item.word}} </td>
                             </tr>
             
                              <tr *ngIf="sktwithoutsandhi.checked == true">
                                <td>  {{item.sandhied_word}} </td>
                            </tr>

                            <tr *ngIf="multimorf.checked == true">
                                <td>  {{item.morph_analysis}} </td>
                            </tr>

                            <tr *ngIf="mrfInContext.checked == true">
                                <td> 
                                    <!-- <a href="https://sanskrit.uohyd.ac.in/cgi-bin/scl/e-readers/sbg/options1.cgi?word={{getStem(item.morph_in_context)}}&outencoding=DEV" target="popup" onclick="window.open('','popup','width=600,height=600')" style="color:black;text-decoration:underline;"> {{getStem(item.morph_in_context)}}</a>  -->
                                    {{getStem2(item.morph_in_context)}}
                                         <a href="https://sanskrit.uohyd.ac.in/cgi-bin/scl/e-readers/sbg/options1.cgi?word={{item.stem}}&outencoding=DEV"  target="popup" onclick="window.open('','popup','width=600,height=600')" style="color:black;text-decoration:underline;" *ngFor="let item of stems; let i=index"> <span *ngIf="i>0">-</span>{{item.stem}} </a> 
                                       
                                    {{"{"+getFeat(item.morph_in_context)}}</td>
                                   
                            </tr>

                            <tr *ngIf="samaasa.checked == true">
                             
                                <td> 
                                    <a *ngIf="item.samAsa !='-'" style="color:black;text-decoration: underline;" (click)="createGraph(item.samAsa)" class="modal-trigger" href="#showCompGraph"> {{item.samAsa}} </a> 
                                    <a *ngIf="item.samAsa =='-'"> {{item.samAsa}} </a> 
                                </td>
                            </tr>

                            <tr *ngIf="samaasavigraha.checked == true">
                                <td>  {{item.samAsa}}. </td>
                            </tr>
            
                            <tr *ngIf="kaarakarel.checked == true">
                                <td>  {{item.kaaraka_sambandha}} </td>
                            </tr>
            
                            <tr *ngIf="cate.checked == true">
                                <td>  --- </td>
                            </tr>
                            <tr *ngIf="hindimean.checked == true">
                                <td>  {{item.hindi_meaning}}</td>
                            </tr>
            
                            <tr *ngIf="engmean.checked == true">
                                <td>  {{item.english_meaning}}</td>
                            </tr>
                            <tr *ngIf="derimean.checked == true">
                                <td>  --- </td>
                            </tr>
                            <tr *ngIf="sandhirule.checked == true">
                                <td>  --- </td>
                            </tr> 
                             <tr *ngIf="meter.checked == true">
                                <td>  --- </td>
                            </tr>
                            
                         </table>
                    
                    </li>
                </ul>
            </div>
            <div class="col s12 l4">
                <div  class="center sticky" *ngIf="(sentFiveStat == 'yes'  && sentFive.checked == true)">
                    <a class="modal-trigger" href="#modal2" (click)="showGraf(sentFiveGraf)"> <img src="{{sentFiveGraf}}" width="100%" height="200px"> </a>
        
                </div>
            </div>
        </div>

<!-- Sixth Analysis  -->
                        
<div class="row">
    <div class="col s12 l8">
        <ul *ngIf="(sentSixStat == 'yes' && sentSix.checked == true)">
            <li style='float:left;position: relative;'>
                <table> 
                    <tr *ngIf="wordNo.checked == true">
                        <td> Word No. </td>
                    </tr>
                    <tr (click)="showGraf('6')" *ngIf="sanskrit.checked == true">
                        <td class="pink-text">  1.6.A. </td>
                    </tr>
                    <tr *ngIf="sktwithoutsandhi.checked == true">
                        <td>  1.6.B. </td>
                    </tr>

                    <tr *ngIf="multimorf.checked == true">
                        <td>  1.6.C. </td>
                    </tr>

                    <tr *ngIf="mrfInContext.checked == true">
                        <td>  1.6.D. </td>
                    </tr>

                    <tr *ngIf="samaasa.checked == true">
                        <td>  1.6.E. </td>
                    </tr>

                    <tr *ngIf="samaasavigraha.checked == true">
                        <td>  1.6.F. </td>
                    </tr>
    
                    <tr *ngIf="kaarakarel.checked == true">
                        <td>  1.6.G. </td>
                    </tr>
    
                    <tr *ngIf="cate.checked == true">
                        <td>  1.6.H.</td>
                    </tr>
                    <tr *ngIf="hindimean.checked == true">
                        <td>  1.6.I.</td>
                    </tr>
    
                    <tr *ngIf="engmean.checked == true">
                        <td>  1.6.J.</td>
                    </tr>
                    <tr *ngIf="derimean.checked == true">
                        <td>  1.6.K.</td>
                    </tr>
                    <tr *ngIf="sandhirule.checked == true">
                        <td>  1.6.L.</td>
                    </tr>
                    <tr *ngIf="meter.checked == true">
                        <td>  1.6.M.</td>
                    </tr>
                    
    
                    
                    
                </table>
            </li>
            <li *ngFor="let item of sentSixAna;let i=index" [style.background-color]="item.bgcolor" (click)="showGraf(item.graph)">
                <table> 
                    <tr *ngIf="wordNo.checked == true">
                        <td> {{i+1}}</td>
                    </tr> 
                     <tr *ngIf="sanskrit.checked == true">
                         <td>  {{item.word}} </td>
                     </tr>
     
                      <tr *ngIf="sktwithoutsandhi.checked == true">
                        <td>  {{item.sandhied_word}} </td>
                    </tr>

                    <tr *ngIf="multimorf.checked == true">
                        <td>  {{item.morph_analysis}} </td>
                    </tr>

                    <tr *ngIf="mrfInContext.checked == true">
                        <td> 
                            <!-- <a href="https://sanskrit.uohyd.ac.in/cgi-bin/scl/e-readers/sbg/options1.cgi?word={{getStem(item.morph_in_context)}}&outencoding=DEV" target="popup" onclick="window.open('','popup','width=600,height=600')" style="color:black;text-decoration:underline;"> {{getStem(item.morph_in_context)}}</a>  -->
                            {{getStem2(item.morph_in_context)}}
                            <a href="https://sanskrit.uohyd.ac.in/cgi-bin/scl/e-readers/sbg/options1.cgi?word={{item.stem}}&outencoding=DEV"  target="popup" onclick="window.open('','popup','width=600,height=600')" style="color:black;text-decoration:underline;" *ngFor="let item of stems; let i=index"> <span *ngIf="i>0">-</span>{{item.stem}} </a> 
                                       
                            {{"{"+getFeat(item.morph_in_context)}}</td>
                                   
                    </tr>

                    <tr *ngIf="samaasa.checked == true">
                        <td> 
                            <a *ngIf="item.samAsa !='-'" style="color:black;text-decoration: underline;" (click)="createGraph(item.samAsa)" class="modal-trigger" href="#showCompGraph"> {{item.samAsa}} </a> 
                            <a *ngIf="item.samAsa =='-'"> {{item.samAsa}} </a> 
                        </td>
                    </tr>

                    <tr *ngIf="samaasavigraha.checked == true">
                        <td>  {{item.samAsa}}. </td>
                    </tr>
    
                    <tr *ngIf="kaarakarel.checked == true">
                        <td>  {{item.kaaraka_sambandha}} </td>
                    </tr>
    
                    <tr *ngIf="cate.checked == true">
                        <td>  --- </td>
                    </tr>
                    <tr *ngIf="hindimean.checked == true">
                        <td>  {{item.hindi_meaning}}</td>
                    </tr>
    
                    <tr *ngIf="engmean.checked == true">
                        <td>  {{item.english_meaning}}</td>
                    </tr>
                    <tr *ngIf="derimean.checked == true">
                        <td>  --- </td>
                    </tr>
                    <tr *ngIf="sandhirule.checked == true">
                        <td>  --- </td>
                    </tr> 
                     <tr *ngIf="meter.checked == true">
                        <td>  --- </td>
                    </tr>
                    
                 </table>
            
            </li>
        </ul>
    </div>
    <div class="col s12 l4">
        <div  class="center sticky" *ngIf="(sentSixStat == 'yes'  && sentSix.checked == true)">
            <a class="modal-trigger" href="#modal2" (click)="showGraf(sentSixGraf)"> <img src="{{sentSixGraf}}" width="100%" height="200px"> </a>

        </div>
    </div>
</div>


<!-- Seventh Analysis  -->
                        
<div class="row">
    <div class="col s12 l8">
        <ul *ngIf="(sentSevenStat == 'yes' && sentSeven.checked == true)">
            <li style='float:left;position: relative;'>
                <table> 
                    <tr *ngIf="wordNo.checked == true">
                        <td> Word No. </td>
                    </tr>
                    <tr (click)="showGraf('7')" *ngIf="sanskrit.checked == true">
                        <td class="pink-text">  1.7.A. </td>
                    </tr>
                    <tr *ngIf="sktwithoutsandhi.checked == true">
                        <td>  1.7.B. </td>
                    </tr>

                    <tr *ngIf="multimorf.checked == true">
                        <td>  1.7.C. </td>
                    </tr>

                    <tr *ngIf="mrfInContext.checked == true">
                        <td>  1.7.D. </td>
                    </tr>

                    <tr *ngIf="samaasa.checked == true">
                        <td>  1.7.E. </td>
                    </tr>

                    <tr *ngIf="samaasavigraha.checked == true">
                        <td>  1.7.F. </td>
                    </tr>
    
                    <tr *ngIf="kaarakarel.checked == true">
                        <td>  1.7.G. </td>
                    </tr>
    
                    <tr *ngIf="cate.checked == true">
                        <td>  1.7.H.</td>
                    </tr>
                    <tr *ngIf="hindimean.checked == true">
                        <td>  1.7.I.</td>
                    </tr>
    
                    <tr *ngIf="engmean.checked == true">
                        <td>  1.7.J.</td>
                    </tr>
                    <tr *ngIf="derimean.checked == true">
                        <td>  1.7.K.</td>
                    </tr>
                    <tr *ngIf="sandhirule.checked == true">
                        <td>  1.7.L.</td>
                    </tr>
                    <tr *ngIf="meter.checked == true">
                        <td>  1.7.M.</td>
                    </tr>
                    
    
                    
                    
                </table>
            </li>
            <li *ngFor="let item of sentSevenAna;let i=index" [style.background-color]="item.bgcolor" (click)="showGraf(item.graph)">
                <table> 
                    <tr *ngIf="wordNo.checked == true">
                        <td> {{i+1}}</td>
                    </tr> 
                     <tr *ngIf="sanskrit.checked == true">
                         <td>  {{item.word}} </td>
                     </tr>
     
                      <tr *ngIf="sktwithoutsandhi.checked == true">
                        <td>  {{item.sandhied_word}} </td>
                    </tr>

                    <tr *ngIf="multimorf.checked == true">
                        <td>  {{item.morph_analysis}} </td>
                    </tr>

                    <tr *ngIf="mrfInContext.checked == true">
                        <td> 
                            <!-- <a href="https://sanskrit.uohyd.ac.in/cgi-bin/scl/e-readers/sbg/options1.cgi?word={{getStem(item.morph_in_context)}}&outencoding=DEV" target="popup" onclick="window.open('','popup','width=600,height=600')" style="color:black;text-decoration:underline;"> {{getStem(item.morph_in_context)}}</a>  -->
                            {{getStem2(item.morph_in_context)}}
                                         <a href="https://sanskrit.uohyd.ac.in/cgi-bin/scl/e-readers/sbg/options1.cgi?word={{item.stem}}&outencoding=DEV"  target="popup" onclick="window.open('','popup','width=600,height=600')" style="color:black;text-decoration:underline;" *ngFor="let item of stems; let i=index"> <span *ngIf="i>0">-</span>{{item.stem}} </a> 
                                       
                            {{"{"+getFeat(item.morph_in_context)}}</td>
                                   
                    </tr>

                    <tr *ngIf="samaasa.checked == true">
                        <td> 
                            <a *ngIf="item.samAsa !='-'" style="color:black;text-decoration: underline;" (click)="createGraph(item.samAsa)" class="modal-trigger" href="#showCompGraph"> {{item.samAsa}} </a> 
                            <a *ngIf="item.samAsa =='-'"> {{item.samAsa}} </a> 
                        </td>
                       
                    </tr>

                    <tr *ngIf="samaasavigraha.checked == true">
                        <td>  {{item.samAsa}}. </td>
                    </tr>
    
                    <tr *ngIf="kaarakarel.checked == true">
                        <td>  {{item.kaaraka_sambandha}} </td>
                    </tr>
    
                    <tr *ngIf="cate.checked == true">
                        <td>  --- </td>
                    </tr>
                    <tr *ngIf="hindimean.checked == true">
                        <td>  {{item.hindi_meaning}}</td>
                    </tr>
    
                    <tr *ngIf="engmean.checked == true">
                        <td>  {{item.english_meaning}}</td>
                    </tr>
                    <tr *ngIf="derimean.checked == true">
                        <td>  --- </td>
                    </tr>
                    <tr *ngIf="sandhirule.checked == true">
                        <td>  --- </td>
                    </tr> 
                     <tr *ngIf="meter.checked == true">
                        <td>  --- </td>
                    </tr>
                    
                 </table>
            
            </li>
        </ul>
    </div>
    <div class="col s12 l4">
        <div  class="center sticky" *ngIf="(sentSevenStat == 'yes'  && sentSeven.checked == true)">
            <a class="modal-trigger" href="#modal2" (click)="showGraf(sentSevenGraf)"> <img src="{{sentSevenGraf}}" width="100%" height="200px"> </a>

        </div>
    </div>
</div>


<!-- 1a Analysis  -->
                        
<div class="row">
    <div class="col s12 l8">
        <ul *ngIf="(sentOneAStat == 'yes' && sentOneA.checked == true)">
            <li style='float:left;position: relative;'>
                <table> 
                    <tr *ngIf="wordNo.checked == true">
                        <td> Word No. </td>
                    </tr>
                    <tr (click)="showGraf('1a')" *ngIf="sanskrit.checked == true">
                        <td class="pink-text">  1a.1.A. </td>
                    </tr>
                    <tr *ngIf="sktwithoutsandhi.checked == true">
                        <td>  1a.1.B. </td>
                    </tr>

                    <tr *ngIf="multimorf.checked == true">
                        <td>  1a.1.C. </td>
                    </tr>

                    <tr *ngIf="mrfInContext.checked == true">
                        <td>  1a.1.D. </td>
                    </tr>

                    <tr *ngIf="samaasa.checked == true">
                        <td>  1a.1.E. </td>
                    </tr>

                    <tr *ngIf="samaasavigraha.checked == true">
                        <td>  1a.1.F. </td>
                    </tr>
    
                    <tr *ngIf="kaarakarel.checked == true">
                        <td>  1a.1.G. </td>
                    </tr>
    
                    <tr *ngIf="cate.checked == true">
                        <td>  1a.1.H.</td>
                    </tr>
                    <tr *ngIf="hindimean.checked == true">
                        <td>  1a.1.I.</td>
                    </tr>
    
                    <tr *ngIf="engmean.checked == true">
                        <td>  1a.1.J.</td>
                    </tr>
                    <tr *ngIf="derimean.checked == true">
                        <td>  1a.1.K.</td>
                    </tr>
                    <tr *ngIf="sandhirule.checked == true">
                        <td>  1a.1.L.</td>
                    </tr>
                    <tr *ngIf="meter.checked == true">
                        <td>  1a.1.M.</td>
                    </tr>
                    
    
                    
                    
                </table>
            </li>
            <li *ngFor="let item of sentOneAAna;let i=index" [style.background-color]="item.bgcolor" (click)="showGraf(item.graph)">
                <table> 
                    <tr *ngIf="wordNo.checked == true">
                        <td> {{i+1}}</td>
                    </tr> 
                     <tr *ngIf="sanskrit.checked == true">
                         <td>  {{item.word}} </td>
                     </tr>
     
                      <tr *ngIf="sktwithoutsandhi.checked == true">
                        <td>  {{item.sandhied_word}} </td>
                    </tr>

                    <tr *ngIf="multimorf.checked == true">
                        <td>  {{item.morph_analysis}} </td>
                    </tr>

                    <tr *ngIf="mrfInContext.checked == true">
                        <td>
                             <!-- <a href="https://sanskrit.uohyd.ac.in/cgi-bin/scl/e-readers/sbg/options1.cgi?word={{getStem(item.morph_in_context)}}&outencoding=DEV" target="popup" onclick="window.open('','popup','width=600,height=600')" style="color:black;text-decoration:underline;"> {{getStem(item.morph_in_context)}}</a>  -->
                             {{getStem2(item.morph_in_context)}}
                             <a href="https://sanskrit.uohyd.ac.in/cgi-bin/scl/e-readers/sbg/options1.cgi?word={{item.stem}}&outencoding=DEV"  target="popup" onclick="window.open('','popup','width=600,height=600')" style="color:black;text-decoration:underline;" *ngFor="let item of stems; let i=index"> <span *ngIf="i>0">-</span>{{item.stem}} </a> 
                           
                            {{"{"+getFeat(item.morph_in_context)}}</td>
                                   
                    </tr>

                    <tr *ngIf="samaasa.checked == true">
                        <td> 
                            <a *ngIf="item.samAsa !='-'" style="color:black;text-decoration: underline;" (click)="createGraph(item.samAsa)" class="modal-trigger" href="#showCompGraph"> {{item.samAsa}} </a> 
                            <a *ngIf="item.samAsa =='-'"> {{item.samAsa}} </a> 
                        </td>
                       
                    </tr>

                    <tr *ngIf="samaasavigraha.checked == true">
                        <td>  {{item.samAsa}}. </td>
                    </tr>
    
                    <tr *ngIf="kaarakarel.checked == true">
                        <td>  {{item.kaaraka_sambandha}} </td>
                    </tr>
    
                    <tr *ngIf="cate.checked == true">
                        <td>  --- </td>
                    </tr>
                    <tr *ngIf="hindimean.checked == true">
                        <td>  {{item.hindi_meaning}}</td>
                    </tr>
    
                    <tr *ngIf="engmean.checked == true">
                        <td>  {{item.english_meaning}}</td>
                    </tr>
                    <tr *ngIf="derimean.checked == true">
                        <td>  --- </td>
                    </tr>
                    <tr *ngIf="sandhirule.checked == true">
                        <td>  --- </td>
                    </tr> 
                     <tr *ngIf="meter.checked == true">
                        <td>  --- </td>
                    </tr>
                    
                 </table>
            
            </li>
        </ul>
    </div>
    <div class="col s12 l4">
        <div  class="center sticky" *ngIf="(sentOneAStat == 'yes'  && sentOneA.checked == true)">
            <a class="modal-trigger" href="#modal2" (click)="showGraf(sentOneAGraf)"> <img src="{{sentOneAGraf}}" width="100%" height="200px"> </a>

        </div>
    </div>
</div>


<!-- 1b Analysis  -->
                        
<div class="row">
    <div class="col s12 l8">
        <ul *ngIf="(sentOneBStat == 'yes' && sentOneB.checked == true)">
            <li style='float:left;position: relative;'>
                <table> 
                    <tr *ngIf="wordNo.checked == true">
                        <td> Word No. </td>
                    </tr>
                    <tr (click)="showGraf('1b')" *ngIf="sanskrit.checked == true">
                        <td class="pink-text">  1b.1.A. </td>
                    </tr>
                    <tr *ngIf="sktwithoutsandhi.checked == true">
                        <td>  1b.1.B. </td>
                    </tr>

                    <tr *ngIf="multimorf.checked == true">
                        <td>  1b.1.C. </td>
                    </tr>

                    <tr *ngIf="mrfInContext.checked == true">
                        <td>  1b.1.D. </td>
                    </tr>

                    <tr *ngIf="samaasa.checked == true">
                        <td>  1b.1.E. </td>
                    </tr>

                    <tr *ngIf="samaasavigraha.checked == true">
                        <td>  1b.1.F. </td>
                    </tr>
    
                    <tr *ngIf="kaarakarel.checked == true">
                        <td>  1b.1.G. </td>
                    </tr>
    
                    <tr *ngIf="cate.checked == true">
                        <td>  1b.1.H.</td>
                    </tr>
                    <tr *ngIf="hindimean.checked == true">
                        <td>  1b.1.I.</td>
                    </tr>
    
                    <tr *ngIf="engmean.checked == true">
                        <td>  1b.1.J.</td>
                    </tr>
                    <tr *ngIf="derimean.checked == true">
                        <td>  1b.1.K.</td>
                    </tr>
                    <tr *ngIf="sandhirule.checked == true">
                        <td>  1b.1.L.</td>
                    </tr>
                    <tr *ngIf="meter.checked == true">
                        <td>  1b.1.M.</td>
                    </tr>
                    
    
                    
                    
                </table>
            </li>
            <li *ngFor="let item of sentOneBAna;let i=index" [style.background-color]="item.bgcolor" (click)="showGraf(item.graph)">
                <table> 
                    <tr *ngIf="wordNo.checked == true">
                        <td> {{i+1}}</td>
                    </tr> 
                     <tr *ngIf="sanskrit.checked == true">
                         <td>  {{item.word}} </td>
                     </tr>
     
                      <tr *ngIf="sktwithoutsandhi.checked == true">
                        <td>  {{item.sandhied_word}} </td>
                    </tr>

                    <tr *ngIf="multimorf.checked == true">
                        <td>  {{item.morph_analysis}} </td>
                    </tr>

                    <tr *ngIf="mrfInContext.checked == true">
                        <td> 
                            <!-- <a href="https://sanskrit.uohyd.ac.in/cgi-bin/scl/e-readers/sbg/options1.cgi?word={{getStem(item.morph_in_context)}}&outencoding=DEV" target="popup" onclick="window.open('','popup','width=600,height=600')" style="color:black;text-decoration:underline;"> {{getStem(item.morph_in_context)}}</a>  -->
                            {{getStem2(item.morph_in_context)}}
                                         <a href="https://sanskrit.uohyd.ac.in/cgi-bin/scl/e-readers/sbg/options1.cgi?word={{item.stem}}&outencoding=DEV"  target="popup" onclick="window.open('','popup','width=600,height=600')" style="color:black;text-decoration:underline;" *ngFor="let item of stems; let i=index"> <span *ngIf="i>0">-</span>{{item.stem}} </a> 
                                       
                            {{"{"+getFeat(item.morph_in_context)}}</td>
                                   
                    </tr>

                    <tr *ngIf="samaasa.checked == true">
                        <td> 
                            <a *ngIf="item.samAsa !='-'" style="color:black;text-decoration: underline;" (click)="createGraph(item.samAsa)" class="modal-trigger" href="#showCompGraph"> {{item.samAsa}} </a> 
                            <a *ngIf="item.samAsa =='-'"> {{item.samAsa}} </a> 
                        </td>
                    </tr>

                    <tr *ngIf="samaasavigraha.checked == true">
                        <td>  {{item.samAsa}}. </td>
                    </tr>
    
                    <tr *ngIf="kaarakarel.checked == true">
                        <td>  {{item.kaaraka_sambandha}} </td>
                    </tr>
    
                    <tr *ngIf="cate.checked == true">
                        <td>  --- </td>
                    </tr>
                    <tr *ngIf="hindimean.checked == true">
                        <td>  {{item.hindi_meaning}}</td>
                    </tr>
    
                    <tr *ngIf="engmean.checked == true">
                        <td>  {{item.english_meaning}}</td>
                    </tr>
                    <tr *ngIf="derimean.checked == true">
                        <td>  --- </td>
                    </tr>
                    <tr *ngIf="sandhirule.checked == true">
                        <td>  --- </td>
                    </tr> 
                     <tr *ngIf="meter.checked == true">
                        <td>  --- </td>
                    </tr>
                    
                 </table>
            
            </li>
        </ul>
    </div>
    <div class="col s12 l4">
        <div  class="center sticky" *ngIf="(sentOneBStat == 'yes'  && sentOneB.checked == true)">
            <a class="modal-trigger" href="#modal2" (click)="showGraf(sentOneBGraf)"> <img src="{{sentOneBGraf}}" width="100%" height="200px"> </a>

        </div>
    </div>
</div>



<!-- 2a Analysis  -->
                        
<div class="row">
    <div class="col s12 l8">
        <ul *ngIf="(sentTwoAStat == 'yes' && sentTwoA.checked == true)">
            <li style='float:left;position: relative;'>
                <table> 
                    <tr *ngIf="wordNo.checked == true">
                        <td> Word No. </td>
                    </tr>
                    <tr (click)="showGraf('2a')" *ngIf="sanskrit.checked == true">
                        <td class="pink-text">  2a.1.A. </td>
                    </tr>
                    <tr *ngIf="sktwithoutsandhi.checked == true">
                        <td>  2a.1.B. </td>
                    </tr>

                    <tr *ngIf="multimorf.checked == true">
                        <td>  2a.1.C. </td>
                    </tr>

                    <tr *ngIf="mrfInContext.checked == true">
                        <td>  2a.1.D. </td>
                    </tr>

                    <tr *ngIf="samaasa.checked == true">
                        <td>  2a.1.E. </td>
                    </tr>

                    <tr *ngIf="samaasavigraha.checked == true">
                        <td>  2a.1.F. </td>
                    </tr>
    
                    <tr *ngIf="kaarakarel.checked == true">
                        <td>  2a.1.G. </td>
                    </tr>
    
                    <tr *ngIf="cate.checked == true">
                        <td>  2a.1.H.</td>
                    </tr>
                    <tr *ngIf="hindimean.checked == true">
                        <td>  2a.1.I.</td>
                    </tr>
    
                    <tr *ngIf="engmean.checked == true">
                        <td>  2a.1.J.</td>
                    </tr>
                    <tr *ngIf="derimean.checked == true">
                        <td>  2a.1.K.</td>
                    </tr>
                    <tr *ngIf="sandhirule.checked == true">
                        <td>  2a.1.L.</td>
                    </tr>
                    <tr *ngIf="meter.checked == true">
                        <td>  2a.1.M.</td>
                    </tr>                    
                    
                </table>
            </li>
            <li *ngFor="let item of sentTwoAAna;let i=index" [style.background-color]="item.bgcolor" (click)="showGraf(item.graph)">
                <table> 
                    <tr *ngIf="wordNo.checked == true">
                        <td> {{i+1}}</td>
                    </tr> 
                     <tr *ngIf="sanskrit.checked == true">
                         <td>  {{item.word}} </td>
                     </tr>
     
                      <tr *ngIf="sktwithoutsandhi.checked == true">
                        <td>  {{item.sandhied_word}} </td>
                    </tr>

                    <tr *ngIf="multimorf.checked == true">
                        <td>  {{item.morph_analysis}} </td>
                    </tr>

                    <tr *ngIf="mrfInContext.checked == true">
                        <td> 
                            <!-- <a href="https://sanskrit.uohyd.ac.in/cgi-bin/scl/e-readers/sbg/options1.cgi?word={{getStem(item.morph_in_context)}}&outencoding=DEV" target="popup" onclick="window.open('','popup','width=600,height=600')" style="color:black;text-decoration:underline;"> {{getStem(item.morph_in_context)}}</a>  -->
                            {{getStem2(item.morph_in_context)}}
                                         <a href="https://sanskrit.uohyd.ac.in/cgi-bin/scl/e-readers/sbg/options1.cgi?word={{item.stem}}&outencoding=DEV"  target="popup" onclick="window.open('','popup','width=600,height=600')" style="color:black;text-decoration:underline;" *ngFor="let item of stems; let i=index"> <span *ngIf="i>0">-</span>{{item.stem}} </a> 
                                       
                            {{"{"+getFeat(item.morph_in_context)}}</td>
                                   
                    </tr>

                    <tr *ngIf="samaasa.checked == true">
                        <td> 
                            <a *ngIf="item.samAsa !='-'" style="color:black;text-decoration: underline;" (click)="createGraph(item.samAsa)" class="modal-trigger" href="#showCompGraph"> {{item.samAsa}} </a>  
                            <a *ngIf="item.samAsa =='-'"> {{item.samAsa}} </a> 
                        </td>
                    </tr>

                    <tr *ngIf="samaasavigraha.checked == true">
                        <td>  {{item.samAsa}}. </td>
                    </tr>
    
                    <tr *ngIf="kaarakarel.checked == true">
                        <td>  {{item.kaaraka_sambandha}} </td>
                    </tr>
    
                    <tr *ngIf="cate.checked == true">
                        <td>  --- </td>
                    </tr>
                    <tr *ngIf="hindimean.checked == true">
                        <td>  {{item.hindi_meaning}}</td>
                    </tr>
    
                    <tr *ngIf="engmean.checked == true">
                        <td>  {{item.english_meaning}}</td>
                    </tr>
                    <tr *ngIf="derimean.checked == true">
                        <td>  --- </td>
                    </tr>
                    <tr *ngIf="sandhirule.checked == true">
                        <td>  --- </td>
                    </tr> 
                     <tr *ngIf="meter.checked == true">
                        <td>  --- </td>
                    </tr>
                    
                 </table>
            
            </li>
        </ul>
    </div>
    <div class="col s12 l4">
        <div  class="center sticky" *ngIf="(sentTwoAStat == 'yes'  && sentTwoA.checked == true)">
            <a class="modal-trigger" href="#modal2" (click)="showGraf(sentTwoAGraf)"> <img src="{{sentTwoAGraf}}" width="100%" height="200px"> </a>

        </div>
    </div>
</div>




<!-- 2b Analysis  -->
                        
<div class="row">
    <div class="col s12 l8">
        <ul *ngIf="(sentTwoBStat == 'yes' && sentTwoB.checked == true)">
            <li style='float:left;position: relative;'>
                <table> 
                    <tr *ngIf="wordNo.checked == true">
                        <td> Word No. </td>
                    </tr>
                    <tr (click)="showGraf('2b')" *ngIf="sanskrit.checked == true">
                        <td class="pink-text">  2b.1.A. </td>
                    </tr>
                    <tr *ngIf="sktwithoutsandhi.checked == true">
                        <td>  2b.1.B. </td>
                    </tr>

                    <tr *ngIf="multimorf.checked == true">
                        <td>  2b.1.C. </td>
                    </tr>

                    <tr *ngIf="mrfInContext.checked == true">
                        <td>  2b.1.D. </td>
                    </tr>

                    <tr *ngIf="samaasa.checked == true">
                        <td>  2b.1.E. </td>
                    </tr>

                    <tr *ngIf="samaasavigraha.checked == true">
                        <td>  2b.1.F. </td>
                    </tr>
    
                    <tr *ngIf="kaarakarel.checked == true">
                        <td>  2b.1.G. </td>
                    </tr>
    
                    <tr *ngIf="cate.checked == true">
                        <td>  2b.1.H.</td>
                    </tr>
                    <tr *ngIf="hindimean.checked == true">
                        <td>  2b.1.I.</td>
                    </tr>
    
                    <tr *ngIf="engmean.checked == true">
                        <td>  2b.1.J.</td>
                    </tr>
                    <tr *ngIf="derimean.checked == true">
                        <td>  2b.1.K.</td>
                    </tr>
                    <tr *ngIf="sandhirule.checked == true">
                        <td>  2b.1.L.</td>
                    </tr>
                    <tr *ngIf="meter.checked == true">
                        <td>  2b.1.M.</td>
                    </tr>                    
                    
                </table>
            </li>
            <li *ngFor="let item of sentTwoBAna;let i=index" [style.background-color]="item.bgcolor" (click)="showGraf(item.graph)">
                <table> 
                    <tr *ngIf="wordNo.checked == true">
                        <td> {{i+1}}</td>
                    </tr> 
                     <tr *ngIf="sanskrit.checked == true">
                         <td>  {{item.word}} </td>
                     </tr>
     
                      <tr *ngIf="sktwithoutsandhi.checked == true">
                        <td>  {{item.sandhied_word}} </td>
                    </tr>

                    <tr *ngIf="multimorf.checked == true">
                        <td>  {{item.morph_analysis}} </td>
                    </tr>

                    <tr *ngIf="mrfInContext.checked == true">
                        <td> 
                            <!-- <a href="https://sanskrit.uohyd.ac.in/cgi-bin/scl/e-readers/sbg/options1.cgi?word={{getStem(item.morph_in_context)}}&outencoding=DEV" target="popup" onclick="window.open('','popup','width=600,height=600')" style="color:black;text-decoration:underline;"> {{getStem(item.morph_in_context)}}</a>  -->
                            {{getStem2(item.morph_in_context)}}
                                         <a href="https://sanskrit.uohyd.ac.in/cgi-bin/scl/e-readers/sbg/options1.cgi?word={{item.stem}}&outencoding=DEV"  target="popup" onclick="window.open('','popup','width=600,height=600')" style="color:black;text-decoration:underline;" *ngFor="let item of stems; let i=index"> <span *ngIf="i>0">-</span>{{item.stem}} </a> 
                                       
                            {{"{"+getFeat(item.morph_in_context)}}</td>
                                   
                    </tr>

                    <tr *ngIf="samaasa.checked == true">
                        <td> 
                            <a *ngIf="item.samAsa !='-'" style="color:black;text-decoration: underline;" (click)="createGraph(item.samAsa)" class="modal-trigger" href="#showCompGraph"> {{item.samAsa}} </a> 
                            <a *ngIf="item.samAsa =='-'"> {{item.samAsa}} </a> 
                        </td>
                    </tr>

                    <tr *ngIf="samaasavigraha.checked == true">
                        <td>  {{item.samAsa}}. </td>
                    </tr>
    
                    <tr *ngIf="kaarakarel.checked == true">
                        <td>  {{item.kaaraka_sambandha}} </td>
                    </tr>
    
                    <tr *ngIf="cate.checked == true">
                        <td>  --- </td>
                    </tr>
                    <tr *ngIf="hindimean.checked == true">
                        <td>  {{item.hindi_meaning}}</td>
                    </tr>
    
                    <tr *ngIf="engmean.checked == true">
                        <td>  {{item.english_meaning}}</td>
                    </tr>
                    <tr *ngIf="derimean.checked == true">
                        <td>  --- </td>
                    </tr>
                    <tr *ngIf="sandhirule.checked == true">
                        <td>  --- </td>
                    </tr> 
                     <tr *ngIf="meter.checked == true">
                        <td>  --- </td>
                    </tr>
                    
                 </table>
            
            </li>
        </ul>
    </div>
    <div class="col s12 l4">
        <div  class="center sticky" *ngIf="(sentTwoBStat == 'yes'  && sentTwoB.checked == true)">
            <a class="modal-trigger" href="#modal2" (click)="showGraf(sentTwoBGraf)"> <img src="{{sentTwoBGraf}}" width="100%" height="200px"> </a>

        </div>
    </div>
</div>




</li>



    </ul>

    
        <br><br>
       
    <!-- </div>col ends here -->

<!-- </div> -->

    <!-- {{grafLink}} -->
    

</div>


<div id="modal2" class="modal bottom-sheet">
    <div class="modal-content">
        <img src="{{grafLink}}" width="100%" height="500px">
    </div>
    <div class="modal-footer grey lighten-1">
      <a href="#!" class="modal-close waves-effect waves-green btn-flat">Close</a>
    </div>
  </div>

<!-- 
<div id="modal3" class="modal">
    <div class="modal-content">
        <img src="{{compGraphLink}}" class="img-responsive">
    </div>
    <div class="modal-footer grey lighten-1">
      <a href="#!" class="modal-close waves-effect waves-green btn-flat">Close</a>
    </div>
  </div> -->



<div class="section white z-depth-4" id="show">
    <div class="container center">
       

<a class="waves-effect waves-light btn-flat modal-trigger" href="#modal1">Show/Hide</a>

    </div>
    <div id="modal1" class="modal modal-fixed-footer">
        <div class="modal-content">
            <h5> Show & Hide Features</h5><hr>

            <p> <label>
                <input type="checkbox" #wordNo (click)="show()" />
                <span>Show Word No. (Index number)</span>
              </label> 
            </p>
            <p> <label>
                <input type="checkbox" #sanskrit (click)="show()" checked/>
                <span> Sanskrit (A) </span>
            </label> 
            </p>
            
            
            <p> <label>
                <input type="checkbox" #sktwithoutsandhi (click)="show()"/>
                <span> Sanskrit without sandhi (B)</span>
            </label> 
            </p>
            

         <p> <label>
            <input type="checkbox" #multimorf (click)="show()" />
            <span>Multiple Morphology (C)</span>
          </label> 
        </p>
        <p> <label>
            <input type="checkbox" #mrfInContext (click)="show()" checked/>
            <span>Morph in Context (D)</span>
          </label> 
        </p>


        <p> <label>
            <input type="checkbox" #samaasa (click)="show()"/>
            <span> samaasa structural analysis (E)</span>
        </label> 
        </p>
        
        <p> <label>
            <input type="checkbox" #samaasavigraha (click)="show()"/>
            <span> samaasa vigraha (F)</span>
        </label> 
        </p>
        

        <p> <label>
            <input type="checkbox" #kaarakarel (click)="show()" />
            <span>kaaraka relation (G)</span>
          </label> 
        </p>


<p> <label>
    <input type="checkbox" #cate (click)="show()"/>
    <span> Category (H)</span>
</label> 
</p>

<p> <label>
    <input type="checkbox" #hindimean (click)="show()" checked/>
    <span> Hindi Meaning (I)</span>
</label> 
</p>

<p> <label>
    <input type="checkbox" #engmean (click)="show()"/>
    <span> English Meaning (J)</span>
</label> 
</p>

<p> <label>
    <input type="checkbox" #derimean (click)="show()"/>
    <span> Derivational Meaning (K)</span>
</label> 
</p>

<p> <label>
    <input type="checkbox" #sandhirule (click)="show()"/>
    <span> Sandhi rules(L)</span>
</label> 
</p>

<p> <label>
    <input type="checkbox" #meter (click)="show()"/>
    <span> Meter: Guru-Laghu(M)</span>
</label> 
</p>

<p> <label>
    <input type="checkbox" #unde (click)="show()"/>
    <span> undefined</span>
</label> 
</p>

        <p> <label>
            <input type="checkbox" #sentOne  (click)="show()" checked disabled="disabled" />
            <span>Sent 1 </span>
          </label> &nbsp;&nbsp;
         <label>
            <input type="checkbox" #sentTwo (click)="show()" checked/>
            <span>Sent 2 </span>
          </label> &nbsp;&nbsp;
          <label>
            <input type="checkbox" #sentThree (click)="show()" checked/>
            <span>Sent 3 </span>
          </label>&nbsp;&nbsp;
          <label>
            <input type="checkbox" #sentFour (click)="show()" checked/>
            <span>Sent 4 </span>
          </label>&nbsp;&nbsp;
          <label>
            <input type="checkbox" #sentFive (click)="show()" checked/>
            <span>Sent 5 </span>
          </label>&nbsp;&nbsp;
          <label>
            <input type="checkbox" #sentSix (click)="show()" checked/>
            <span>Sent 6 </span>
          </label>&nbsp;&nbsp;
          <label>
            <input type="checkbox" #sentSeven (click)="show()" checked/>
            <span>Sent 7 </span>
          </label>
        </p>

        <p> <label>
            <input type="checkbox" #sentOneA  (click)="show()" checked />
            <span>Sent 1a </span>
          </label> &nbsp;&nbsp;
         <label>
            <input type="checkbox" #sentOneB (click)="show()" checked/>
            <span>Sent 1b </span>
          </label> &nbsp;&nbsp;
          <label>
            <input type="checkbox" #sentTwoA (click)="show()" checked/>
            <span>Sent 2a </span>
          </label>&nbsp;&nbsp;
          <label>
            <input type="checkbox" #sentTwoB (click)="show()" checked/>
            <span>Sent 2b </span>
          </label>&nbsp;&nbsp;
          
        </p>

        </div>
        <div class="modal-footer">
          <a  class="modal-close waves-effect waves-green btn-flat">Close</a>
        </div>
      </div>

</div>
